export function paginate<T>(array: T[], pageSize: number, currentPage: number, prevPageSize = 10): T[] {
  const startPosition = (currentPage - 1) * prevPageSize;
  return array.slice(startPosition, startPosition + pageSize);
}